import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ngxPlural',
  standalone: true,
})
export class PluralPipe implements PipeTransform {
  public transform(input: number, label: string, pluralLabel = ''): string {
    input = input || 0;
    return input === 1
      ? `${input} ${label}`
      : pluralLabel
        ? `${input} ${pluralLabel}`
        : `${input} ${label}s`;
  }
}
